import React from 'react';
import { MessageCircle, ArrowDown, Award, Zap, ShieldCheck, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
const badgeIcons = [Award, Zap, ShieldCheck, DollarSign];
export function Hero() {
  const {
    t
  } = useLang();
  return <section className="relative min-h-[90vh] flex flex-col justify-center overflow-hidden" data-id="element-152" data-mp="4mrxb9ifkfpg">
      {/* Full-bleed background image */}
      <img src="https://cdn.magicpatterns.com/uploads/291wi5FGm7SZuRDHLwxpjd/aselite.png" alt={t.hero.imageAlt} className="absolute inset-0 w-full h-full object-cover object-[center_70%]" data-id="element-153" data-mp="127edlbj0jlce" />
      {/* Dark scrim for readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/80 to-dark/60" data-id="element-154" data-mp="nb6mrsd3nlo5"></div>
      <div className="absolute inset-0 bg-dark/40" data-id="element-155" data-mp="3d2l9jc5qb50p"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 lg:pt-40 lg:pb-20 text-center" data-id="element-156" data-mp="381xkux4z309n">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 drop-shadow-2xl" data-id="element-157" data-mp="3j9kazboofhg4">
          {t.hero.titleA}{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-600" data-id="element-158" data-mp="30gq4l654cxni">
            {t.hero.titleHighlight}
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-4 text-gray-200 font-bold" data-id="element-159" data-mp="2qkdaw89kqjsr">
            {t.hero.titleSub}
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-160" data-mp="2vgllr9gqnqu4">
          {t.hero.subtitleBefore}{' '}
          <strong className="text-white" data-id="element-161" data-mp="ibgnz0l3xvmv">{t.hero.subtitlePrice}</strong>{' '}
          {t.hero.subtitleAfter}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-162" data-mp="deq92gl1h631">
          <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-dark bg-gold hover:bg-gold-400 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-163" data-mp="x0csinnygqiq">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-164" data-mp="21by07aom32dz" />
            {t.hero.ctaWhatsapp}
          </a>
          <a href="#portafolio" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-white border border-white/30 bg-dark/40 backdrop-blur-sm hover:bg-white/10 transition-all" data-id="element-165" data-mp="268y71ntac965">
            {t.hero.ctaWork} <ArrowDown className="w-4 h-4 ml-2" data-id="element-166" data-mp="2kydryn64xkdx" />
          </a>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto border-t border-white/10 pt-10" data-id="element-167" data-mp="2p1jxfslfb7jc">
          {t.hero.badges.map((text, i) => {
          const Icon = badgeIcons[i];
          return <motion.div key={i} whileHover={{
            y: -5
          }} className="flex flex-col items-center justify-center p-4 rounded-2xl hover:bg-white/5 transition-colors cursor-default" data-id="element-168" data-mp="4d73uw8q0vx5" data-mpi={i}>
                <Icon className="w-8 h-8 text-gold mb-3" data-id="element-169" data-mp="9b8m5eybor7k" />
                <span className="text-sm font-medium text-gray-300 text-center" data-id="element-170" data-mp="3hphdkjp3zby5">
                  {text}
                </span>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}